// ===== REBUILT JAVASCRIPT - CLEAN ARCHITECTURE =====

// Global State Management
const BundleState = {
  currentSize: 1,
  selections: {
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    6: null
  }
};

const BUNDLE_DISCOUNTS = {
  2: 1000,
  3: 2500,
  6: 6000
};

let isProductFormSubmitting = false;
let stickyCheckoutTrigger = null;

function getProductFormWrapper() {
  return document.querySelector('.product-form-wrapper');
}

function getDefaultVariantData() {
  const wrapper = getProductFormWrapper();
  if (!wrapper) return null;

  const id = wrapper.dataset.defaultVariantId;
  const price = Number(wrapper.dataset.defaultPrice);
  if (!id || !Number.isFinite(price)) return null;

  return {
    id,
    name: wrapper.dataset.defaultVariantName || '',
    price,
    comparePrice: Number(wrapper.dataset.defaultComparePrice) || 0,
    available: wrapper.dataset.defaultAvailable === 'true',
    preorder: wrapper.dataset.defaultPreorder === 'true',
    inventory: Number(wrapper.dataset.defaultInventory),
    inventoryManagement: wrapper.dataset.defaultInventoryManagement || ''
  };
}

function getVariantDataFromSwatch(swatch) {
  if (!swatch) return null;

  const price = Number(swatch.dataset.price);
  return {
    id: swatch.dataset.variantId,
    name: swatch.dataset.variantName || '',
    price: Number.isFinite(price) ? price : 0,
    comparePrice: Number(swatch.dataset.comparePrice) || 0,
    available: swatch.dataset.available === 'true',
    preorder: swatch.dataset.preorder === 'true',
    inventory: Number(swatch.dataset.inventory),
    inventoryManagement: swatch.dataset.inventoryManagement || '',
    element: swatch
  };
}

function hasVariantSwatches() {
  return document.querySelector('.variant-swatch') !== null;
}

function getCurrentBundleVariants() {
  if (!hasVariantSwatches()) {
    const defaultVariant = getDefaultVariantData();
    return defaultVariant
      ? Array.from({ length: BundleState.currentSize }, () => ({ ...defaultVariant }))
      : [];
  }

  const variants = [];
  for (let i = 1; i <= BundleState.currentSize; i++) {
    if (BundleState.selections[i]) variants.push(BundleState.selections[i]);
  }
  return variants;
}

function getBundlePurchaseState() {
  const variants = getCurrentBundleVariants();
  const availableDesignCount = document.querySelectorAll('.variant-swatch[data-available="true"]').length;
  const canFulfill = hasVariantSwatches()
    ? availableDesignCount > 0
    : Boolean(variants[0]?.available);

  return {
    variants,
    complete: variants.length === BundleState.currentSize,
    canFulfill,
    hasUnavailable: variants.some(variant => !variant.available),
    hasPreorder: variants.some(variant => variant.preorder),
    missing: Math.max(0, BundleState.currentSize - variants.length)
  };
}

function getBundleSubtotal() {
  const state = getBundlePurchaseState();
  if (!state.complete || state.hasUnavailable) return null;
  return state.variants.reduce((total, variant) => total + variant.price, 0);
}

function showProductFormError(message) {
  const errorElement = document.getElementById('product-form-error');
  if (!errorElement) return;

  if (!message) {
    errorElement.textContent = '';
    errorElement.hidden = true;
    return;
  }

  errorElement.textContent = message;
  errorElement.hidden = false;
  errorElement.focus({ preventScroll: true });
}

async function getCartErrorMessage(response) {
  try {
    const errorData = await response.json();
    return errorData.description || errorData.message || errorData.error || `Unable to add this item (${response.status}).`;
  } catch (error) {
    return response.statusText || `Unable to add this item (${response.status}).`;
  }
}

// ===== MEDIA HANDLING =====
function playProductVideo(video) {
  if (!video) return;

  video.muted = true;
  video.playsInline = true;
  video.play().catch(() => {
    video.controls = true;
  });
}

function changeMainMedia(thumbnail, mediaType) {
  const mainWrapper = document.getElementById('main-media-wrapper');
  if (!mainWrapper || !thumbnail) return;

  // Update active thumbnail
  document.querySelectorAll('.thumbnail, .video-thumbnail').forEach(thumb => {
    thumb.classList.remove('active');
    thumb.setAttribute('aria-pressed', 'false');
  });
  thumbnail.classList.add('active');
  thumbnail.setAttribute('aria-pressed', 'true');

  // Hide all media items and pause videos
  document.querySelectorAll('.media-item').forEach(item => {
    item.style.display = 'none';
    const video = item.querySelector('video');
    if (video && !video.paused) {
      video.pause();
    }
  });

  // Show selected media
  const mediaId = thumbnail.dataset.mediaId;
  const selectedMedia = document.querySelector(`.media-item[data-media-id="${mediaId}"]`);

  if (selectedMedia) {
    selectedMedia.style.display = 'block';

    if (mediaType === 'video') {
      const video = selectedMedia.querySelector('video');
      if (video) {
        video.currentTime = 0;
        playProductVideo(video);
      }
    }
  }

  // Carousel no longer tied to variant selection
}

function initializeMediaThumbnails() {
  document.querySelectorAll('.thumbnail, .video-thumbnail').forEach((thumbnail) => {
    if (thumbnail.dataset.keyboardReady === 'true') return;
    thumbnail.dataset.keyboardReady = 'true';
    thumbnail.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      changeMainMedia(thumbnail, thumbnail.dataset.mediaType);
    });
  });
}

function initializeProductVideos() {
  const activeThumbnail = document.querySelector('.video-thumbnail.active');
  if (!activeThumbnail) return;

  const activeMedia = document.querySelector(
    `.media-item[data-media-id="${activeThumbnail.dataset.mediaId}"]`
  );
  playProductVideo(activeMedia?.querySelector('video'));
}

// ===== BUNDLE SELECTION SYSTEM =====
function selectBundle(bundleSize) {
  const requestedTab = document.querySelector(`.bundle-tab[data-bundle="${bundleSize}"]`);
  if (![1, 2, 3, 6].includes(bundleSize) || requestedTab?.disabled) return;

  // Update state
  BundleState.currentSize = bundleSize;
  showProductFormError('');

  // Update UI
  updateBundleTabs(bundleSize);
  updateVariantSelectors(bundleSize);
  updateQuantity();
  updateShippingBadge(bundleSize);

  // Auto-select all variants when bundle size is 6
  if (bundleSize === 6) {
    autoSelectAllVariants();
  }

  updatePricing(bundleSize);
  updatePreOrderNotice();

  // Show appropriate initial message
  showBundleMessage(bundleSize);

  // Update sticky checkout
  updateStickyCheckout();
}


function updateBundleTabs(bundleSize) {
  document.querySelectorAll('.bundle-tab').forEach(tab => {
    tab.classList.remove('active');
  });
  const activeTab = document.querySelector(`.bundle-tab[data-bundle="${bundleSize}"]`);
  if (activeTab) activeTab.classList.add('active');
}

function updateVariantSelectors(bundleSize) {
  // Clear selections when changing bundle size
  clearAllSelections();

  // Update swatch grid based on bundle size
  const swatchGrid = document.getElementById('variant-swatches-grid');
  if (swatchGrid) {
    swatchGrid.dataset.bundleSize = bundleSize;
  }

  // Quantity badges removed per user request

  updateSelectionCounter();
  updateSwatchTitle();
}

function updateQuantity() {
  const qtyInput = document.getElementById('quantity');

  // Always keep quantity at 1 to prevent payment buttons from adding multiples
  if (qtyInput) qtyInput.value = 1;
}

function updatePricing(bundleSize) {
  const unitPriceEl = document.querySelector('.unit-price-text');
  if (!unitPriceEl || !window.CurrencyFormatter) return;

  const CF = window.CurrencyFormatter;
  const subtotal = getBundleSubtotal();
  const wrapper = getProductFormWrapper();
  const priceMin = Number(wrapper?.dataset.priceMin);
  const fallbackSubtotal = Number.isFinite(priceMin) ? priceMin * bundleSize : null;
  const displayedSubtotal = subtotal ?? fallbackSubtotal;
  const cartDiscount = BUNDLE_DISCOUNTS[bundleSize] || 0;
  const discountedSubtotal = displayedSubtotal === null
    ? null
    : Math.max(displayedSubtotal - cartDiscount, 0);
  const formattedSubtotal = displayedSubtotal === null ? '' : CF.format(displayedSubtotal);
  const formattedDiscountedSubtotal = discountedSubtotal === null ? '' : CF.format(discountedSubtotal);
  const priceElement = document.querySelector(`[data-bundle-price="${bundleSize}"]`);
  const originalPriceElement = document.querySelector(`[data-bundle-original-price="${bundleSize}"]`);
  const pricePrefix = document.querySelector(`[data-bundle-price-prefix="${bundleSize}"]`);
  const comparePriceElement = document.getElementById('bundle-compare-price');
  const freeShippingItemThreshold = Number(window.themeSettings?.freeShippingItemThreshold) || 1;
  const includesFreeShipping = bundleSize >= freeShippingItemThreshold;

  if (priceElement && formattedDiscountedSubtotal) {
    priceElement.textContent = formattedDiscountedSubtotal;
    priceElement.setAttribute(
      'aria-label',
      cartDiscount ? `Price after discount ${formattedDiscountedSubtotal}` : `Subtotal ${formattedDiscountedSubtotal}`
    );
  }
  if (originalPriceElement && formattedSubtotal) {
    originalPriceElement.textContent = formattedSubtotal;
    originalPriceElement.setAttribute('aria-label', `Original subtotal ${formattedSubtotal}`);
  }
  if (pricePrefix) {
    pricePrefix.textContent = subtotal === null ? 'From' : cartDiscount ? 'In cart' : 'Subtotal';
  }
  if (bundleSize === 1 && comparePriceElement) {
    const selectedVariant = getBundlePurchaseState().variants[0];
    const showComparePrice = Boolean(selectedVariant && selectedVariant.comparePrice > selectedVariant.price);
    comparePriceElement.hidden = !showComparePrice;
    if (showComparePrice) comparePriceElement.textContent = CF.format(selectedVariant.comparePrice);
  }

  if (subtotal === null) {
    const designLabel = bundleSize === 1 ? 'design' : `${bundleSize} designs`;
    unitPriceEl.textContent = `Choose ${designLabel} to see your exact subtotal.`;
    return;
  }

  const totalLabel = cartDiscount ? 'In cart' : 'Subtotal';
  const discountText = cartDiscount ? ` · Save ${CF.format(cartDiscount)}` : '';
  const shippingText = includesFreeShipping ? ' · Free shipping' : ' · Shipping at checkout';
  unitPriceEl.textContent = `${totalLabel}: ${formattedDiscountedSubtotal}${discountText}${shippingText}`;
}

function updateAddToCartButton(bundleSize) {
  const btn = document.getElementById('add-to-cart-btn');
  const btnText = document.getElementById('add-to-cart-text');
  if (!btn) return;
  const stickyButton = document.getElementById('sticky-add-to-cart');
  const stickyText = document.getElementById('sticky-add-to-cart-text');
  const state = getBundlePurchaseState();

  let buttonText = bundleSize > 1 ? 'Add bundle to cart' : 'Add to cart';
  if (isProductFormSubmitting) {
    buttonText = 'Adding…';
  } else if (!state.canFulfill || state.hasUnavailable) {
    buttonText = 'Sold out';
  } else if (!state.complete) {
    buttonText = `Choose ${state.missing} more`;
  } else if (state.hasPreorder) {
    buttonText = 'Pre-order';
  }

  const disabled = isProductFormSubmitting || !state.canFulfill || state.hasUnavailable || !state.complete;
  btn.disabled = disabled;
  btn.setAttribute('aria-disabled', String(disabled));
  btn.setAttribute('aria-busy', String(isProductFormSubmitting));
  if (btnText) btnText.textContent = buttonText;

  if (stickyButton) {
    stickyButton.disabled = disabled;
    stickyButton.setAttribute('aria-disabled', String(disabled));
    stickyButton.setAttribute('aria-busy', String(isProductFormSubmitting));
  }
  if (stickyText) stickyText.textContent = buttonText === 'Add bundle to cart' ? 'Add bundle' : buttonText;
}

function updateShippingBadge(bundleSize) {
  const shippingBadgeText = document.getElementById('shipping-badge-text');
  if (!shippingBadgeText) return;
  const freeShippingItemThreshold = Number(window.themeSettings?.freeShippingItemThreshold) || 1;
  shippingBadgeText.textContent = bundleSize >= freeShippingItemThreshold
    ? 'Free Shipping Included!'
    : `Free Shipping on ${freeShippingItemThreshold}+`;
}

// ===== SWATCH SELECTION SYSTEM =====
function toggleSwatchSelection(variantId) {
  const swatch = document.querySelector(`.variant-swatch[data-variant-id="${variantId}"]`);
  if (!swatch) return;
  if (swatch.disabled || swatch.dataset.available !== 'true') {
    showProductFormError('That design is currently sold out. Please choose another one.');
    return;
  }

  // The card makes the first selection. Once selected, the visible stepper is
  // the explicit way to add or remove copies of that design.
  if (getSelectedVariantCount(variantId) > 0) return;
  if (getCurrentBundleVariants().length >= BundleState.currentSize) {
    if (BundleState.currentSize === 1) {
      for (let i = 1; i <= 6; i++) BundleState.selections[i] = null;
      selectSwatch(swatch);
      refreshBundleSelectionUI();
      return;
    }
    showProductFormError('Your bundle is full. Remove one towel before choosing another.');
    return;
  }
  selectSwatch(swatch);
  refreshBundleSelectionUI();
}

function adjustSwatchQuantity(variantId, change) {
  const swatch = document.querySelector(`.variant-swatch[data-variant-id="${variantId}"]`);
  if (!swatch || swatch.disabled || swatch.dataset.available !== 'true') return;

  if (change > 0) {
    if (getCurrentBundleVariants().length >= BundleState.currentSize) {
      showProductFormError('Your bundle is full. Remove one towel before adding another.');
      return;
    }
    selectSwatch(swatch);
  } else if (change < 0) {
    removeVariantSelection(variantId);
  }

  refreshBundleSelectionUI();
}

function refreshBundleSelectionUI() {
  syncAllSwatchSelectionStates();
  updateSelectionCounter();
  updateBundleInputs();
  updateSwatchTitle();
  updateCharacterDialogue();
  updatePricing(BundleState.currentSize);
  updateSelectedVariantStock();
  updateStickyCheckout();
  showProductFormError('');
}

function selectSwatch(swatch) {
  if (!swatch || swatch.disabled || swatch.dataset.available !== 'true') return;

  const variant = getVariantDataFromSwatch(swatch);

  // Add to selections
  const selectionIndex = getNextSelectionIndex();
  if (selectionIndex !== null) {
    BundleState.selections[selectionIndex] = variant;
    syncSwatchSelectionState(swatch);
  }

  // Main image no longer changes on selection
}

function removeVariantSelection(variantId) {
  const selections = [];
  let removed = false;

  for (let i = 1; i <= 6; i++) {
    const selection = BundleState.selections[i];
    if (!selection) continue;
    if (!removed && selection.id === variantId) {
      removed = true;
      continue;
    }
    selections.push(selection);
  }

  for (let i = 1; i <= 6; i++) {
    BundleState.selections[i] = selections[i - 1] || null;
  }
}

function getSelectedVariantCount(variantId) {
  let count = 0;
  for (let i = 1; i <= 6; i++) {
    if (BundleState.selections[i]?.id === variantId) count++;
  }
  return count;
}

function syncSwatchSelectionState(swatch) {
  const count = getSelectedVariantCount(swatch.dataset.variantId);
  const isSelected = count > 0;
  const countBadge = swatch.querySelector('.swatch-selection-count');
  const card = swatch.closest('.variant-swatch-card');
  const quantityControls = card?.querySelector('.swatch-quantity-controls');
  const quantityValue = card?.querySelector('.swatch-quantity-value');
  const increaseButton = card?.querySelector('[data-swatch-action="increase"]');
  const variantName = swatch.dataset.variantName || 'Design';

  swatch.classList.toggle('selected', isSelected);
  swatch.setAttribute('aria-pressed', String(isSelected));
  swatch.setAttribute('aria-label', `${variantName}, ${count} selected`);
  swatch.dataset.selectionCount = String(count);

  if (countBadge) {
    countBadge.textContent = `×${count}`;
    countBadge.hidden = count < 2;
  }
  if (quantityControls) quantityControls.hidden = !isSelected;
  if (quantityValue) {
    quantityValue.textContent = String(count);
    quantityValue.setAttribute('aria-label', `${count} ${variantName} selected`);
  }
  if (increaseButton) {
    const bundleIsFull = getCurrentBundleVariants().length >= BundleState.currentSize;
    increaseButton.disabled = bundleIsFull;
    increaseButton.setAttribute('aria-disabled', String(bundleIsFull));
  }
}

function syncAllSwatchSelectionStates() {
  document.querySelectorAll('.variant-swatch').forEach(syncSwatchSelectionState);
}

function getNextSelectionIndex() {
  for (let i = 1; i <= 6; i++) {
    if (!BundleState.selections[i]) return i;
  }
  return null;
}

function updateSelectionCounter() {
  const selectedCount = getCurrentBundleVariants().length;
  const counter = document.querySelector('.selected-count');
  const maxCount = document.querySelector('.max-count');

  if (counter) counter.textContent = selectedCount;
  if (maxCount) maxCount.textContent = BundleState.currentSize;
}

function updateBundleInputs() {
  // Update hidden inputs based on selections
  for (let i = 1; i <= 6; i++) {
    const input = document.getElementById(`variant-select-${i}`);
    if (input) {
      const value = BundleState.selections[i] ? BundleState.selections[i].id : '';
      input.value = value;
    }
  }
  
  // Check if any selected variant is out of stock
  updatePreOrderNotice();
}

function updatePreOrderNotice() {
  const preOrderNotice = document.getElementById('pre-order-notice');
  if (!preOrderNotice) return;
  const state = getBundlePurchaseState();
  preOrderNotice.hidden = !(state.complete && state.hasPreorder && !state.hasUnavailable);
  updateAddToCartButton(BundleState.currentSize);
}

function updateSelectedVariantStock() {
  const stockIndicator = document.getElementById('selected-variant-stock');
  if (!stockIndicator) return;

  const variant = getCurrentBundleVariants()[0];
  const stockIcon = stockIndicator.querySelector('.stock-icon');
  const stockText = stockIndicator.querySelector('.stock-text');
  const lowStockThreshold = Number(stockIndicator.dataset.lowStockThreshold) || 5;

  if (!variant) {
    stockIndicator.hidden = true;
    return;
  }

  let message = '';
  let icon = '';
  if (!variant.available) {
    message = 'Sold out';
    icon = '✕';
  } else if (variant.preorder) {
    message = 'Available for pre-order';
    icon = '📦';
  } else if (variant.inventoryManagement === 'shopify' && variant.inventory > 0 && variant.inventory <= lowStockThreshold) {
    message = `Low stock — only ${variant.inventory} left`;
    icon = '⚠️';
  }

  stockIndicator.hidden = !message;
  stockIndicator.classList.toggle('low-stock', message.startsWith('Low stock'));
  if (stockIcon) stockIcon.textContent = icon;
  if (stockText) stockText.textContent = message;
}


function updateSwatchTitle() {
  const title = document.getElementById('swatches-title');
  if (!title) return;

  const titles = {
    1: 'Choose One:',
    2: 'Choose Two:',
    3: 'Choose Three:',
    6: 'Choose Six:'
  };

  title.textContent = titles[BundleState.currentSize] || titles[1];
}

// ===== CHARACTER DIALOGUE SYSTEM =====
const characterDialogues = {
  'ATAGO': {
    personality: 'shy',
    dialogues: [
      "I-I can feel how tired you are... I promise I'll help you relax... 💕",
      "You work so hard... I want to make your bath time special...",
      "You're being so gentle with me... Let me be soft and warm for you... *blushes*"
    ]
  },
  'YUUKI': {
    personality: 'flirty',
    dialogues: [
      "I see those tired eyes... Don't worry, I'll make them sparkle again~ 😘",
      "You deserve to be pampered after working so hard... Leave it to me~ ❤️",
      "I can already imagine your smile when you feel how soft I am~ 💋"
    ]
  },
  'SORA': {
    personality: 'wise',
    dialogues: [
      "In all my years, I've learned to recognize someone who needs care... and you do~",
      "Your aura tells me you've been carrying so much stress... Let me lift it for you 🌸",
      "I've waited centuries for someone who truly needs my comfort... It's you ✨"
    ]
  },
  'KURUMI': {
    personality: 'sassy',
    dialogues: [
      "Hmph! You look exhausted... N-not that I care! I just... want to help you...",
      "You better appreciate how absorbent I am! All your stress will disappear!",
      "I-it's obvious you need proper care... Lucky for you, I'm here!"
    ]
  },
  'TOKI': {
    personality: 'mommy',
    dialogues: [
      "Oh my, those tired shoulders... Mommy knows exactly what you need~ 💜",
      "You've been working too hard, haven't you? Let me take all that stress away...",
      "Such a precious soul... You deserve the softest, warmest care~ 🌙"
    ]
  },
  'MIKA': {
    personality: 'bold',
    dialogues: [
      "I can tell you need someone who takes charge... Lucky for you, I'm here! 💪",
      "No more stress for you! I'll make sure every worry melts away, guaranteed! ⚡",
      "You look like you could use my special treatment... Get ready to feel amazing! 🔥"
    ]
  },
  'ASA': {
    personality: 'earnest',
    dialogues: [
      "I may overthink everything... but making you feel better is one thing I'm sure about. 🌙",
      "You look exhausted. Please let me help—I've thought this through very carefully.",
      "No clever line this time... I just want you to relax and feel cared for. ✨"
    ]
  }
};


let currentTypewriterTimeout = null;
let messageQueue = [];
let isProcessingMessage = false;

function typewriterEffect(text, element, speed = 15, callback) {
  // Clear any existing timeout
  if (currentTypewriterTimeout) {
    clearTimeout(currentTypewriterTimeout);
  }

  element.textContent = '';
  let index = 0;

  function type() {
    if (index < text.length) {
      element.textContent += text.charAt(index);
      index++;
      currentTypewriterTimeout = setTimeout(type, speed);
    } else if (callback) {
      callback();
    }
  }

  type();
}

function addMessageToHistory(speaker, message) {
  const historyContainer = document.getElementById('dialogue-history');
  if (!historyContainer) return;

  // Create new message element
  const messageEl = document.createElement('div');
  messageEl.className = 'dialogue-message latest';
  messageEl.innerHTML = `<span class="message-speaker">${speaker}:</span><span class="message-text"></span>`;

  // Update previous messages' classes
  const existingMessages = historyContainer.querySelectorAll('.dialogue-message');
  existingMessages.forEach((msg, index) => {
    msg.classList.remove('latest', 'previous-1', 'previous-2', 'previous-3');
    if (index === existingMessages.length - 1) {
      msg.classList.add('previous-1');
    } else if (index === existingMessages.length - 2) {
      msg.classList.add('previous-2');
    } else if (index === existingMessages.length - 3) {
      msg.classList.add('previous-3');
    }
  });

  // Remove oldest message if we have 4 or more
  if (existingMessages.length >= 4) {
    existingMessages[0].remove();
  }

  // Add new message
  historyContainer.appendChild(messageEl);

  // Apply typewriter effect to the message text
  const messageTextEl = messageEl.querySelector('.message-text');
  typewriterEffect(message, messageTextEl, 15, () => {
    // Auto-scroll to bottom
    historyContainer.scrollTop = historyContainer.scrollHeight;

    // Process next message in queue after delay
    setTimeout(() => {
      isProcessingMessage = false;
      processMessageQueue();
    }, 1500);
  });
}

function processMessageQueue() {
  if (isProcessingMessage || messageQueue.length === 0) return;

  isProcessingMessage = true;
  const { speaker, message, character } = messageQueue.shift();

  // Update speaking portrait
  const portraits = document.querySelectorAll('.character-portrait');
  portraits.forEach((p, index) => {
    const isSpeaking = p.dataset.character === character;
    p.classList.toggle('speaking', isSpeaking);

    // Dynamic z-index: speaking character gets highest z-index
    if (isSpeaking) {
      p.style.zIndex = '10'; // Highest z-index for speaking character
    } else {
      // Other characters get decreasing z-index based on their position
      p.style.zIndex = `${9 - index}`;
    }
  });

  addMessageToHistory(speaker, message);
}


function updateCharacterDialogue() {
  const dialogueBox = document.getElementById('character-dialogue-box');
  const portraitsContainer = document.getElementById('character-portraits');
  const characterNameEl = document.getElementById('character-name');
  const dialogueHistory = document.getElementById('dialogue-history');

  if (!dialogueBox || !portraitsContainer) return;

  // Get selected characters
  const selectedCharacters = [];
  for (let i = 1; i <= BundleState.currentSize; i++) {
    if (BundleState.selections[i]) {
      const swatch = BundleState.selections[i].element;
      if (swatch) {
        const variantName = swatch.dataset.variantName;
        const characterName = variantName.split(' ')[0].toUpperCase();
        const imageUrl = swatch.querySelector('.swatch-image')?.src;
        if (characterDialogues[characterName]) {
          selectedCharacters.push({
            name: characterName,
            image: imageUrl,
            data: characterDialogues[characterName]
          });
        }
      }
    }
  }

  // Check if bundle is fully selected
  const bundleComplete = selectedCharacters.length === BundleState.currentSize;

  if (!bundleComplete || selectedCharacters.length === 0) {
    dialogueBox.style.display = 'none';
    // Clear any existing messages when bundle is incomplete
    if (dialogueHistory) {
      dialogueHistory.innerHTML = '';
    }
    messageQueue = [];
    isProcessingMessage = false;
    return;
  }

  // Show dialogue box only when bundle is complete
  dialogueBox.style.display = 'block';

  // Clear and populate portraits
  portraitsContainer.innerHTML = '';
  selectedCharacters.forEach((char, index) => {
    const portrait = document.createElement('div');
    portrait.className = `character-portrait ${index === 0 ? 'speaking' : ''}`;
    portrait.innerHTML = `<img src="${char.image}" alt="${char.name}" />`;
    portrait.dataset.character = char.name;

    // Set initial z-index: first character (speaking) gets highest, others get decreasing
    if (index === 0) {
      portrait.style.zIndex = '10'; // Speaking character on top
    } else {
      portrait.style.zIndex = `${9 - index}`; // Others get decreasing z-index
    }


    portraitsContainer.appendChild(portrait);
  });

  // Clear message queue and history
  messageQueue = [];
  isProcessingMessage = false;
  if (dialogueHistory) {
    dialogueHistory.innerHTML = '';
  }

  // Create message queue - each character speaks individually
  if (selectedCharacters.length === 1) {
    characterNameEl.textContent = selectedCharacters[0].name;
  } else if (selectedCharacters.length === 2) {
    characterNameEl.textContent = selectedCharacters.map(c => c.name).join(' & ');
  } else {
    characterNameEl.textContent = 'Your Harem';
  }

  // Each character speaks individually with their own dialogue
  selectedCharacters.forEach((char) => {
    const randomIndex = Math.floor(Math.random() * char.data.dialogues.length);
    messageQueue.push({
      speaker: char.name,
      message: char.data.dialogues[randomIndex],
      character: char.name
    });
  });

  // Start processing messages
  if (messageQueue.length > 0) {
    processMessageQueue();
  }
}

function showBundleMessage() {
  // Update dialogue when bundle size changes
  setTimeout(updateCharacterDialogue, 100);
}


// ===== CLEAR SELECTIONS =====
function clearAllSelections() {
  // Reset bundle state selections
  BundleState.selections = { 1: null, 2: null, 3: null, 4: null, 5: null, 6: null };
  syncAllSwatchSelectionStates();

  // Clear all hidden inputs
  for (let i = 1; i <= 6; i++) {
    const input = document.getElementById(`variant-select-${i}`);
    if (input) {
      input.value = '';
    }
  }

  updateSelectionCounter();
  updateBundleInputs();
  updateCharacterDialogue();
  updatePricing(BundleState.currentSize);
  updateSelectedVariantStock();
  updateStickyCheckout();
}

// ===== AUTO-SELECT ALL VARIANTS FOR BUNDLE 6 =====
function autoSelectAllVariants() {
  // Get all variant swatches
  const availableSwatches = document.querySelectorAll('.variant-swatch[data-available="true"]:not(:disabled)');

  // Select up to 6 variants (all characters)
  let selectionCount = 0;
  availableSwatches.forEach(swatch => {
    if (selectionCount < 6) {
      const variantId = swatch.dataset.variantId;
      if (variantId && !swatch.classList.contains('selected')) {
        selectSwatch(swatch);
        selectionCount++;
      }
    }
  });

  // Update UI after all selections
  updateSelectionCounter();
  updateBundleInputs();
  updateCharacterDialogue();

}

// Variant selection removed from thumbnails - carousel is independent




// ===== SIMPLE DIALOGUE SYSTEM =====




document.addEventListener('DOMContentLoaded', function () {
  // Initialize the bundle before applying the selected variant. This prevents
  // selectBundle() from clearing the initial Shopify-selected variant.
  const currentVariantId = document.getElementById('variant-select-1')?.value;
  selectBundle(1);
  if (hasVariantSwatches()) {
    const currentSwatch = currentVariantId
      ? document.querySelector(`.variant-swatch[data-variant-id="${currentVariantId}"][data-available="true"]`)
      : null;
    const initialSwatch = currentSwatch || document.querySelector('.variant-swatch[data-available="true"]:not(:disabled)');
    if (initialSwatch) selectSwatch(initialSwatch);
  }
  updateSelectionCounter();
  updateBundleInputs();
  updatePricing(BundleState.currentSize);
  updateSelectedVariantStock();
  updateStickyCheckout();

  // Initialize sticky checkout
  initStickyCheckout();

  // Add event delegation for swatches
  document.addEventListener('click', function (e) {
    const quantityButton = e.target.closest('.swatch-quantity-button');
    if (quantityButton) {
      e.preventDefault();
      const change = quantityButton.dataset.swatchAction === 'increase' ? 1 : -1;
      adjustSwatchQuantity(quantityButton.dataset.variantId, change);
      return;
    }

    // Handle swatch clicks
    const swatch = e.target.closest('.variant-swatch');
    if (swatch) {
      e.preventDefault();
      const variantId = swatch.dataset.variantId;
      if (variantId) {
        toggleSwatchSelection(variantId);
      }
      return;
    }
  });

  // Handle form submission for bundles
  const productForm = document.querySelector('.product-form-anime');
  if (productForm) {
    productForm.addEventListener('submit', async function (e) {
      // Check if this is an express checkout button click
      const isExpressCheckout = e.submitter && (
        e.submitter.classList.contains('shopify-payment-button__button') ||
        e.submitter.closest('.shopify-payment-button')
      );

      if (isExpressCheckout && BundleState.currentSize === 1) {
        return;
      }

      e.preventDefault();
      if (isProductFormSubmitting) return;
      const drawerTrigger = stickyCheckoutTrigger || (
        e.submitter instanceof HTMLElement ? e.submitter : document.activeElement
      );
      stickyCheckoutTrigger = null;

      const purchaseState = getBundlePurchaseState();
      if (!purchaseState.canFulfill || purchaseState.hasUnavailable) {
        showProductFormError('One or more selected designs are sold out. Please update your selection.');
        return;
      }
      if (!purchaseState.complete) {
        const noun = purchaseState.missing === 1 ? 'design' : 'designs';
        showProductFormError(`Choose ${purchaseState.missing} more ${noun} before continuing.`);
        return;
      }

      const wrapper = getProductFormWrapper();
      const shopifyRoot = window.Shopify?.routes?.root || '/';
      const cartAddUrl = wrapper?.dataset.cartAddUrl || `${shopifyRoot}cart/add.js`;
      const cartUrl = wrapper?.dataset.cartUrl || `${shopifyRoot}cart`;

      isProductFormSubmitting = true;
      showProductFormError('');
      updateAddToCartButton(BundleState.currentSize);

      try {
        let response;
        if (BundleState.currentSize > 1) {
          const bundleNames = {
            2: '2-Pack Bundle',
            3: '3-Pack Bundle',
            6: '6-Pack Ultimate Collection'
          };
          const items = purchaseState.variants.map((variant, index) => ({
            id: String(variant.id),
            quantity: 1,
            properties: {
              'Bundle Type': bundleNames[BundleState.currentSize],
              'Bundle Position': `Item ${index + 1} of ${BundleState.currentSize}`
            }
          }));

          response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });
        } else {
          response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(productForm)
          });
        }

        if (!response.ok) throw new Error(await getCartErrorMessage(response));
        await response.json();

        let cartRefreshFailed = false;
        if (window.AnimeCart?.fetchCart) {
          try {
            await window.AnimeCart.fetchCart();
          } catch (refreshError) {
            cartRefreshFailed = true;
            console.error('Cart refresh failed after a successful add:', refreshError);
          }
        }

        if (cartRefreshFailed) {
          window.location.assign(cartUrl);
        } else if (window.AnimeCart?.openCartDrawer) {
          window.AnimeCart.openCartDrawer(drawerTrigger);
        } else {
          window.location.assign(cartUrl);
        }
      } catch (error) {
        console.error('Unable to add product to cart:', error);
        showProductFormError(error.message || 'Unable to add this item. Please try again.');
      } finally {
        isProductFormSubmitting = false;
        updatePreOrderNotice();
      }
    });
  }
});

// ===== MOBILE STICKY CHECKOUT =====
function updateStickyCheckout() {
  const stickyCheckout = document.getElementById('mobile-sticky-checkout');
  const stickyPrice = document.getElementById('sticky-unit-price');

  if (!stickyCheckout || !window.CurrencyFormatter) return;

  const CF = window.CurrencyFormatter;
  const subtotal = getBundleSubtotal();
  const state = getBundlePurchaseState();
  if (stickyPrice) {
    const cartDiscount = BUNDLE_DISCOUNTS[BundleState.currentSize] || 0;
    const discountedSubtotal = subtotal === null ? null : Math.max(subtotal - cartDiscount, 0);
    stickyPrice.textContent = subtotal === null
      ? `Select ${state.missing}`
      : `${CF.format(discountedSubtotal)}${cartDiscount ? ' in cart' : BundleState.currentSize > 1 ? ' subtotal' : ''}`;
  }
  updateAddToCartButton(BundleState.currentSize);
}

function triggerMainAddToCart() {
  // Find and trigger the main add to cart button
  const mainAddToCartBtn = document.getElementById('add-to-cart-btn');
  if (mainAddToCartBtn) {
    stickyCheckoutTrigger = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    mainAddToCartBtn.click();
  }
}

function initStickyCheckout() {
  const stickyCheckout = document.getElementById('mobile-sticky-checkout');
  if (!stickyCheckout) return;

  const productMedia = document.querySelector('.product-media');
  if (!productMedia) return;

  const header = document.querySelector('.anime-header');
  let scrollFrame = null;

  function updateVisibility() {
    const triggerLine = header?.getBoundingClientRect().bottom || 0;
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const productMediaPassed = productMedia.getBoundingClientRect().bottom <= triggerLine;
    stickyCheckout.classList.toggle('visible', isMobile && productMediaPassed);
  }

  function requestVisibilityUpdate() {
    if (scrollFrame !== null) return;
    scrollFrame = window.requestAnimationFrame(() => {
      scrollFrame = null;
      updateVisibility();
    });
  }

  window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
  window.addEventListener('resize', requestVisibilityUpdate);
  updateVisibility();
}

// Social sharing
function shareToTikTok() {
  copyShareLink('Link copied! Paste it into TikTok.');
}

function shareToTwitter() {
  const text = "This anime towel is breaking the internet! #AnimeTowel";
  const url = window.location.href;
  window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank', 'noopener,noreferrer');
}

function shareToDiscord() {
  copyShareLink('Link copied! Paste it into Discord.');
}

async function copyShareLink(successMessage) {
  const text = `Check out this cultured towel: ${window.location.href}`;
  try {
    await navigator.clipboard.writeText(text);
    showToast(successMessage);
  } catch (error) {
    showToast('Copy failed. Please copy the page URL from your browser.');
  }
}

// Toast notifications
function showToast(message) {
  const toast = document.createElement('div');
  toast.className = 'anime-toast show';
  toast.setAttribute('role', 'status');
  toast.textContent = message;
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.remove();
  }, 3000);
}

// Removed artificial viewer and stock counter updates for ethical urgency

// Star Rating System
function initializeStarRatings() {
  document.querySelectorAll('.star-rating-input').forEach(ratingContainer => {
    if (ratingContainer.dataset.initialized === 'true') return;
    ratingContainer.dataset.initialized = 'true';

    const stars = ratingContainer.querySelectorAll('.star-input');
    const hiddenInput = ratingContainer.closest('.form-group').querySelector('input[type="hidden"]');

    stars.forEach((star, index) => {
      star.addEventListener('click', () => {
        const rating = index + 1;
        ratingContainer.setAttribute('data-rating', rating);
        if (hiddenInput) hiddenInput.value = rating;

        // Update visual state
        stars.forEach((s, i) => {
          s.setAttribute('aria-pressed', String(i === index));
          if (i < rating) {
            s.classList.add('active');
            s.textContent = '★';
          } else {
            s.classList.remove('active');
            s.textContent = '☆';
          }
        });
      });

      // Hover effect
      star.addEventListener('mouseenter', () => {
        stars.forEach((s, i) => {
          if (i <= index) {
            s.style.color = '#FFD700';
            s.style.transform = 'scale(1.2)';
          }
        });
      });
    });

    // Reset hover effect
    ratingContainer.addEventListener('mouseleave', () => {
      const currentRating = parseInt(ratingContainer.getAttribute('data-rating'));
      stars.forEach((s, i) => {
        s.style.transform = 'scale(1)';
        if (i < currentRating) {
          s.style.color = '#FFD700';
        } else {
          s.style.color = '#CCCCCC';
        }
      });
    });
  });
}

// FAQ Toggle Function
function toggleFAQ(button) {
  const faqItem = button.closest('.faq-item');
  if (!faqItem) return;
  const isActive = faqItem.classList.contains('active');

  // Close all other FAQ items
  document.querySelectorAll('.product-page-anime .faq-item').forEach(item => {
    const shouldOpen = item === faqItem && !isActive;
    item.classList.toggle('active', shouldOpen);
    const itemButton = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    const icon = item.querySelector('.faq-icon');
    itemButton?.setAttribute('aria-expanded', String(shouldOpen));
    answer?.setAttribute('aria-hidden', String(!shouldOpen));
    if (icon) icon.textContent = shouldOpen ? '×' : '+';
  });
}

function initializeProductFAQs() {
  document.querySelectorAll('.product-page-anime .faq-question').forEach((button, index) => {
    const answer = button.closest('.faq-item')?.querySelector('.faq-answer');
    if (!answer) return;

    const answerId = answer.id || `product-faq-answer-${index + 1}`;
    answer.id = answerId;
    button.type = 'button';
    button.setAttribute('aria-controls', answerId);
    button.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
  });
}

function initializeProductInteractions() {
  initializeStarRatings();
  initializeMediaThumbnails();
  initializeProductVideos();
  initializeProductFAQs();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProductInteractions, { once: true });
} else {
  initializeProductInteractions();
}
